export default "__VITE_ASSET__BztR0szL__"